export function getActualDate(date, hoursCount, isToAdd) {
  let actualDate = date;

  if(isToAdd) {
    actualDate.setHours(actualDate.getHours() + hoursCount);
  } else {
    actualDate.setHours(actualDate.getHours() - hoursCount);
  }

  return actualDate;
}
